import {
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Select,
} from '@chakra-ui/react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'next-i18next';

import { TicketType } from '@lib/types';

function TicketsSection({
  onTicketIdChange,
  onQuantityChange,
  tickets,
  selectedTicket,
}: {
  onTicketIdChange: any;
  onQuantityChange: any;
  tickets: TicketType[];
  selectedTicket: TicketType;
}) {
  const { t } = useTranslation();

  const { register } = useFormContext();

  const ticketIdRegister = register('ticketId');
  const quantityRegister = register('quantity');

  return (
    <>
      <Heading
        fontSize="l"
        fontWeight="light"
        pb={4}
        width="full"
        borderBottom="1px"
        borderColor="gray.300"
        mt={4}
      >
        {t('Select Ticket')}
      </Heading>
      <Flex pt={4} pb={4}>
        <FormControl id="ticket" mb={2} mr={2} isRequired>
          <FormLabel>{t('Ticket')}</FormLabel>
          <Select
            {...ticketIdRegister}
            onChange={(e) => {
              ticketIdRegister.onChange(e);
              onTicketIdChange(e.target.value);
            }}
          >
            {tickets.map((t: any) => (
              <option key={t.id} value={t.id}>
                {t.name}
              </option>
            ))}
          </Select>
        </FormControl>

        {selectedTicket?.groupAttendeeNumber > 1 && (
          <FormControl id="quantity" mb={2} isRequired>
            <Flex justify="space-between">
              <FormLabel>{t('Quantity')}</FormLabel>
            </Flex>
            {
              <>
                <Select
                  {...quantityRegister}
                  onChange={(e) => {
                    quantityRegister.onChange(e);
                    onQuantityChange(e.target.value);
                  }}
                >
                  {[...new Array(20)].map((_, idx) => (
                    <option key={idx} value={idx + 1}>
                      {idx + 1}
                    </option>
                  ))}
                </Select>
                {`團購 ${selectedTicket.groupAttendeeNumber} 張以上另有優惠`}
              </>
            }
          </FormControl>
        )}
      </Flex>
    </>
  );
}

export default TicketsSection;
